// ═══════════════════════════════════════════════════════════════════
//  modules/erp/ItemIcon.js
//  ItemIcon
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";
import { ItemSprite } from "./ItemSprite";
import { MC_SLOT, SLOT_SIZE } from "./styles";

export function ItemIcon({ item, ghost, onClick, clickable }) {
  if (!item) {
    return (
      <div style={MC_SLOT}>
        {ghost && <span style={{ fontSize: 16, opacity: 0.18 }}>{ghost}</span>}
      </div>
    );
  }
  const name = (item.iaId || item.id).replace("minecraft:", "").replace(/_/g, " ");
  const slotStyle = clickable ? { ...MC_SLOT, cursor: "pointer" } : MC_SLOT;
  return (
    <div style={slotStyle} title={`${name} ×${item.count}${clickable ? " — cliquer pour agir" : ""}`}
      onClick={clickable && onClick ? onClick : undefined}
      onMouseEnter={clickable ? (e) => (e.currentTarget.style.outline = `2px solid ${THEME.gold}`) : undefined}
      onMouseLeave={clickable ? (e) => (e.currentTarget.style.outline = "none") : undefined}>
      <ItemSprite item={item} px={SLOT_SIZE} />
      {item.count > 1 && (
        <span
          style={{
            position: "absolute", bottom: 0, right: 2, fontSize: 13, color: "#FFFFFF",
            fontWeight: 700, textShadow: "2px 2px 0 #3F3F3F", fontFamily: "'Minecraft', 'Monocraft', monospace",
          }}
        >
          {item.count}
        </span>
      )}
    </div>
  );
}
